import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./addPlantation.css";
import {
  authKey,
  GET_DROPDOWN_FOR_PLANTATION_BATCH,
  ADD_PLANTATION_BATCH,
  UPLOAD_PHOTO,
  EDIT_PLANTATION,
  FETCH_MATURED_DATE,
  CLUMP_LAND_AREA_VALIDATOR,
  DOWNLOAD_DOCUMENT
} from "../../../common/URLs";
import moment from "moment";
import { useLocation } from "react-router-dom";

import jwt from "jwt-decode";
import { loaderService } from "../../../common/custom-loader/loader-service";
import TrashIcon from "../../../images/TrashIcon.png";
import {
  fileNameValidation,
  capitalizeFunction,
  landAreaValidation,
  plantationValidation,
  resourceMaxLength,
  totalNumberOfClumpValidation,
  VALIDATION
} from "../../../common/commonValidations";
import {
  DialogContent,
  Dialog,
  DialogActions,
  Box,
  Link,
  RadioGroup,
  Radio,
  FormControlLabel,
  Fab
} from "@mui/material";
import { getLocalStorageItem } from "../../../common/localStorageUtils";
import { LocationPointMUI } from "../../../common/locationPoints/locationPointMUI";
import {
  allowedFileTypes,
  PROD,
  BASIC_DATE_FORMAT,
  FILE_NAME_VALIDATION_ERROR,
  SQMT_TO_BIGHA_CONVERSION_FACTOR,
  AREA_REQUIRED_FOR_ONE_CLUMP,
  RESOURCE_ROLES
} from "../../../common/constants";
import {
  Container,
  Stack,
  Button,
  Typography,
  Grid,
  FormHelperText,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField
} from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import { format } from "date-fns";
import BackButton from "../../../common/backButton";
import { DataGrid } from "@mui/x-data-grid";
import { useTranslation } from "react-i18next";
import { ConfirmationPopover } from "../../../common/commonPopovers/confirmationPopover";
import { toast } from "react-toastify";
import { handleNumberFieldFocus } from "../../../common/commonFunction";
import apiClient from "../../../axios";
import { KeyboardArrowLeftRounded } from "@mui/icons-material";

function AddPlantation() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const { state } = useLocation();
  const availableClumps =
    Number(state?.batchItem?.possibleClumps) + Number(state?.speciesItem?.noOfClumps);

  const [showhidetype, setShowhidetype] = useState("");
  const [plantDetails, setPlantDetails] = useState("");
  const [showhidesource, setShowhidesource] = useState("");
  const [visible, setVisible] = useState("");
  const [selectedLandArea, setSelectedLandArea] = useState();
  const [selectedLandAreaId, setSelectedLandAreaId] = useState();
  const [urn, setUrn] = useState();
  const [bambooSpecies, setBambooSpecies] = useState();
  const [saplingType, setSaplingType] = useState();
  const [saplingSource, setSaplingSource] = useState();
  const [landAreaUnit, setLandAreaUnit] = useState();
  const [photoUploadDetails, setPhotoUploadDetails] = useState();
  const [selectedPhotoFile, setSelectedPhotoFile] = useState();
  const [growerSponsoreDetails, setGrowerSponsoreDetails] = useState();
  const [growerPlantDetailsUpdate, setGrowerPlantDetailsUpdate] = useState();
  const [growerPlantDetailsError, setGrowerPlantDetailsError] = useState();
  const [addPlantationBatchResponse, setAddPlantationBatchResponse] = useState();
  const [speciesDetailsArr, setSpeciesDetailsArr] = useState([]);
  const [landAreaClumpsValidatorResponse, setLandAreaClumpsValidatorResponse] = useState();
  const [logConfirmModalOpen, setLogConfirmModalOpen] = useState(false);
  const handleConfirmLogModalOpen = () => setLogConfirmModalOpen(true);
  const handleConfirmLogModalClose = () => setLogConfirmModalOpen(false);
  const [logConfirmModalOpenUpdate, setLogConfirmModalOpenUpdate] = useState(false);
  const handleConfirmLogModalOpenUpdate = () => setLogConfirmModalOpenUpdate(true);
  const handleConfirmLogModalCloseUpdate = () => setLogConfirmModalOpenUpdate(false);
  const [logConfirmModalOpenDelete, setLogConfirmModalOpenDelete] = useState(false);
  const handleConfirmLogModalOpenDelete = () => setLogConfirmModalOpenDelete(true);
  const handleConfirmLogModalCloseDelete = () => setLogConfirmModalOpenDelete(false);
  const [deleteIndex, setDeleteIndex] = useState();
  const [documentsArr, setDocumentsArr] = useState([]);
  const [selectedFile, setSelectedFile] = useState();
  const [fileuploadError, setFileuploadError] = useState("");

  const COMMENT_MAX_LENGTH = 500;

  const isPlantationManagerReadOnly =
    !!state?.speciesItem &&
    (getLocalStorageItem("role") === RESOURCE_ROLES.ResPlantationManager ||
      getLocalStorageItem("role") === RESOURCE_ROLES?.ModuleIncharge || getLocalStorageItem('role') === RESOURCE_ROLES?.PlantSCMMember);

  const commentHistoryList = state?.speciesItem?.commentHistory || [];

  const [speciesDetails, setSpeciesDetails] = useState({
    landArea: state?.landArea,
    species: null,
    photoName: null,
    saplingType: null,
    saplingSource: null,
    saplingQuantity: null,
    noOfClumps: null,
    averageClumpSize: null,
    avgBambooPolWgt: null,
    dateOfPlantation: moment(new Date()).format("YYYY-MM-DD"),
    maturedDate: null,
    isMatured: "",
    speciesComment: "",
    spacingLength: null,
    spacingWidth: null,
    latitude: null,
    longitude: null,
    commentDate: moment(new Date()).format("YYYY-MM-DD")
  });

  const [showGrid, setShowGrid] = useState(false);
  const [showSubmitbtn, setShowSubmitbtn] = useState(false);
  const [showAddbtn, setShowAddbtn] = useState(true);

  const [growerPlantDetails, setGrowerPlantDetails] = useState({
    id: "",
    urn: "",
    landId: "",
    latitude: "",
    longitude: "",
    photoName: "",
    photoGuid: "",
    isSponsored: "",
    sponsoredType: "",
    sponsoredRemarks: "",
    sponsoredDocument: "",
    sponsoredDocumentGuid: "",
    dateOfPlantation: moment(new Date()).format("YYYY-MM-DD"),
    threeYrsCompleted: "",
    isMatured: "",
    isApproved: "",
    documentContainerName: "",
    isActive: "",
    createdOn: "",
    createdBy: "",
    updatedOn: "",
    updatedBy: "",
    stateName: state?.state,
    districtName: state?.district,
    growerName: state?.growerName,
    growerType: state?.growerType,
    species: speciesDetailsArr,
    plantation: ""
  });

  const [errorMessage, setErrorMessage] = useState({
    speciesError: "",
    landAreaValueError: "",
    landAreaUnitsError: "",
    saplingTypeError: "",
    otherTypeOfSaplingError: "",
    saplingSourceError: "",
    otherSourceOfSaplingError: "",
    saplingQuantityError: "",
    dateOfPlantationError: "",
    noOfClumpsError: "",
    avgBambooPolWgtError: "",
    photoNameError: "",
    latitudeError: "",
    longitudeError: "",
    sameSpeciesError: "",
    speciesDetailsArrError: "",
    landAreaClumpsValidationError: "",
    isMaturedError: "",
    commentsError: ""
  });

  useEffect(() => {
    setSelectedLandArea(location?.state?.landName);
  }, []);

  useEffect(() => {
    setSelectedLandAreaId(location?.state?.landId);
  }, []);

  useEffect(() => {
    setGrowerSponsoreDetails(location?.state?.sponsoredata);
  }, []);

  useEffect(() => {
    if (getLocalStorageItem("id_token")) {
      const decoded = jwt(getLocalStorageItem("id_token"));
      if (decoded.extension_URN) {
        setUrn(decoded.extension_URN);
      }
    }
  }, [getLocalStorageItem("id_token")]);

  useEffect(() => {
    if (state?.batchItem) {
      setSpeciesDetails({
        ...state?.speciesItem,
        landAreaValue: state?.speciesItem?.landArea?.split(" ")[0],
        landAreaUnits: state?.speciesItem?.landArea?.split(" ")[1],
        dateOfPlantation: moment(state?.speciesItem?.dateOfPlantation).format(BASIC_DATE_FORMAT),
        isMatured: state?.speciesItem?.isMatured || state?.batchItem?.isMatured || "",
        speciesComment: "",
        commentDate: state?.speciesItem?.commentDate
          ? moment(state?.speciesItem?.commentDate).format(BASIC_DATE_FORMAT)
          : moment(new Date()).format(BASIC_DATE_FORMAT)
      });
    }
  }, [state?.speciesItem]);

  useEffect(() => {
    getDropdownValues();
  }, []);

  const getMaturedDate = () => {
    apiClient
      .post(
        FETCH_MATURED_DATE,
        {
          plantationDate: speciesDetails.dateOfPlantation
        },
        {
          headers: {
            Authorization: "Bearer " + getLocalStorageItem("id_token")
          }
        },
        null
      )
      .then((response) => {
        setSpeciesDetails((prev) => {
          if (prev.maturedDate === response.data.plantationMaturedDate) return prev;
          return { ...prev, maturedDate: response.data.plantationMaturedDate };
        });
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const getDropdownValues = () => {
    apiClient
      .post(
        GET_DROPDOWN_FOR_PLANTATION_BATCH,
        {
          urn: urn
        },
        {
          headers: {
            Authorization: "Bearer " + getLocalStorageItem("id_token")
          }
        },
        null
      )
      .then((response) => {
        setBambooSpecies(response.data.Bamboo_species);
        setSaplingType(response.data.Type_of_sapling);
        setSaplingSource(response.data.Source_of_sapling);
        setLandAreaUnit(response.data.Land_area_used);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  useEffect(() => {
    if (selectedPhotoFile) {
      getUploadPhotoDetails();
    }
  }, [selectedPhotoFile]);

  useEffect(() => {
    if (photoUploadDetails) {
      let tempARR = documentsArr ? [...documentsArr] : [];
      photoUploadDetails?.blobResponse && tempARR.push(photoUploadDetails?.blobResponse);
      setDocumentsArr(tempARR);
    }
  }, [photoUploadDetails]);

  const uploadPhoto = (e, type) => {
    if (isPlantationManagerReadOnly) return;
    if (!e?.target?.files?.[0]) return;

    if (allowedFileTypes.indexOf(e.target.files[0].type) < 0) {
      return;
    }
    if (e.target.files[0].size >= 5000000) {
      setFileuploadError("The file should be less than 5MB");
      setSelectedPhotoFile();
    } else if (e.target.files[0].name.split(".").length > 2) {
      setFileuploadError("Double extension file detected");
      setSelectedPhotoFile();
    } else if (fileNameValidation(e.target.files[0].name)) {
      setFileuploadError(FILE_NAME_VALIDATION_ERROR);
      setSelectedPhotoFile();
    } else {
      setSelectedPhotoFile(e.target.files[0]);
      setFileuploadError("");
    }
  };

  function getUploadPhotoDetails() {
    loaderService.showLoader();
    const formData = new FormData();
    formData.append("file", selectedPhotoFile);
    formData.append("fileName", selectedPhotoFile.name);
    formData.append("containerName", "resourcefiles");
    apiClient
      .post(UPLOAD_PHOTO, formData, {
        headers: {
          AuthKey: authKey
        }
      })
      .then((response) => {
        setPhotoUploadDetails(response.data);
        loaderService.hideLoader();
      })

      .catch(function (error) {
        console.log(error);
        loaderService.hideLoader();
      });
  }

  const viewdownloadDocument = (documentBlobName, finalfileName, type) => {
    loaderService.showLoader();
    return fetch(DOWNLOAD_DOCUMENT, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        AuthKey: authKey
      },
      body: JSON.stringify({
        fileName: documentBlobName,
        containerName: "resourcefiles",
        file: ""
      })
    })
      .then((response) => response.blob())
      .then((blob) => {
        if (type === "View") {
          const fileName = finalfileName || "";
          const splittedName = fileName.split(".");
          const fileExtension = splittedName[splittedName.length - 1]?.toLowerCase();
          let fileType;
          switch (fileExtension) {
            case "pdf":
              fileType = "application/pdf";
              break;
            case "png":
              fileType = "image/png";
              break;
            case "jpg":
              fileType = "image/jpeg";
              break;
            case "jpeg":
              fileType = "image/jpeg";
              break;
            default:
              fileType = "application/octet-stream";
          }
          const url = window.URL.createObjectURL(new Blob([blob], { type: fileType }));
          const newWindow = window.open(url, "_blank");
          if (newWindow) newWindow.focus();
        } else {
          const a = document.createElement("a");
          a.style.display = "none";
          document.body.appendChild(a);
          const url = window.URL.createObjectURL(blob);
          a.href = url;
          a.download = finalfileName;
          a.click();
          window.URL.revokeObjectURL(url);
        }
        loaderService.hideLoader();
      })
      .catch(function (error) {
        console.log(error);
        loaderService.hideLoader();
      });
  };

  const handleDateChange = (value) => {
    if (isPlantationManagerReadOnly) return;
    if (!value) return;

    setErrorMessage((prev) => ({ ...prev, dateOfPlantationError: "" }));
    setGrowerPlantDetails((prev) => ({
      ...prev,
      dateOfPlantation: value.format("YYYY-MM-DD")
    }));
    setSpeciesDetails((prev) => ({
      ...prev,
      dateOfPlantation: value.format("YYYY-MM-DD")
    }));
  };

  const handleUpdateChange = (value) => {
    if (isPlantationManagerReadOnly) return;
    if (!value) return;
    setSpeciesDetails((prev) => ({
      ...prev,
      commentDate: value.format("YYYY-MM-DD")
    }));
  };

  const handleChange = (e) => {
    if (isPlantationManagerReadOnly) return;

    const { name, value } = e.target;

    setGrowerPlantDetails((prev) => ({
      ...prev,
      [name]: value
    }));

    if (name === "sameSpecies") {
      setErrorMessage((prev) => ({ ...prev, sameSpeciesError: "" }));
    }
    if (name === "species") {
      setErrorMessage((prev) => ({ ...prev, speciesError: "", sameSpeciesError: "" }));
      setSpeciesDetails((prev) => ({ ...prev, [name]: value }));
      return;
    }
    if (name === "landAreaValue") {
      let slicedLandArea = landAreaValidation(value);
      setSpeciesDetails((prev) => ({
        ...prev,
        landArea: slicedLandArea + " " + prev?.landAreaUnits,
        [name]: slicedLandArea
      }));
      if (slicedLandArea.length == 0) {
        setErrorMessage((prev) => ({ ...prev, landAreaValueError: "Please enter Land Area " }));
      } else {
        setErrorMessage((prev) => ({ ...prev, landAreaValueError: "" }));
      }
      return;
    }
    if (name === "landAreaUnits") {
      setSpeciesDetails((prev) => ({
        ...prev,
        landArea: prev?.landAreaValue + " " + value,
        [name]: value
      }));
      setErrorMessage((prev) => ({ ...prev, landAreaUnitsError: "", sameSpeciesError: "" }));
      return;
    }

    if (name === "saplingType") {
      setErrorMessage((prev) => ({ ...prev, saplingTypeError: "" }));
      setShowhidetype(value);
      setSpeciesDetails((prev) => ({ ...prev, [name]: value }));
      return;
    }

    if (name === "saplingSource") {
      setErrorMessage((prev) => ({ ...prev, saplingSourceError: "" }));
      setShowhidesource(value);
      setSpeciesDetails((prev) => ({ ...prev, [name]: value }));
      return;
    }

    if (name === "saplingQuantity") {
      let slicedVal = plantationValidation(value);
      setSpeciesDetails((prev) => ({ ...prev, [name]: slicedVal }));
      setErrorMessage((prev) => ({ ...prev, saplingQuantityError: "" }));
      return;
    }
    if (name === "spacingLength") {
      let slicedVal = plantationValidation(value);
      setSpeciesDetails((prev) => ({ ...prev, [name]: slicedVal }));
      return;
    }
    if (name === "spacingWidth") {
      let slicedVal = plantationValidation(value);
      setSpeciesDetails((prev) => ({ ...prev, [name]: slicedVal }));
      return;
    }
    if (name === "averageClumpSize") {
      let slicedVal = plantationValidation(value);
      setSpeciesDetails((prev) => ({ ...prev, [name]: slicedVal }));
      return;
    }
    if (name === "dateOfPlantation") {
      setErrorMessage((prev) => ({ ...prev, dateOfPlantationError: "" }));
      setSpeciesDetails((prev) => ({ ...prev, [name]: value }));
      return;
    }

    if (name === "noOfClumps") {
      let slicedLandArea = totalNumberOfClumpValidation(value);
      setSpeciesDetails((prev) => ({ ...prev, [name]: slicedLandArea }));
      if (slicedLandArea.length == 0) {
        setErrorMessage((prev) => ({ ...prev, noOfClumpsError: "Please enter Clump size" }));
      } else {
        setErrorMessage((prev) => ({ ...prev, noOfClumpsError: "", sameSpeciesError: "" }));
      }
      return;
    }

    if (name === "avgBambooPolWgt") {
      let slicedVal = plantationValidation(value);
      setSpeciesDetails((prev) => ({ ...prev, [name]: slicedVal }));
      setErrorMessage((prev) => ({ ...prev, avgBambooPolWgtError: "" }));
      return;
    }

    if (name === "isMatured") {
      setErrorMessage((prev) => ({ ...prev, isMaturedError: "" }));
      setSpeciesDetails((prev) => ({ ...prev, [name]: value }));
      return;
    }

    if (name === "speciesComment") {
      const commentVal = value.slice(0, COMMENT_MAX_LENGTH);
      setErrorMessage((prev) => ({ ...prev, commentsError: "" }));
      setSpeciesDetails((prev) => ({ ...prev, [name]: commentVal }));
      return;
    }

    if (name === "latitude") {
      const limit = 18;
      const latVal = value?.slice(0, limit);
      setSpeciesDetails((prev) => ({ ...prev, [name]: latVal }));
      if (latVal?.length > 0) {
        setErrorMessage((prev) => ({ ...prev, latitudeError: " " }));
      } else {
        setErrorMessage((prev) => ({ ...prev, latitudeError: "Please enter valid latitude" }));
      }
      return;
    }
    if (name === "longitude") {
      const limit = 18;
      const longVal = value?.slice(0, limit);
      setSpeciesDetails((prev) => ({ ...prev, [name]: longVal }));
      if (longVal?.length > 0) {
        setErrorMessage((prev) => ({ ...prev, longitudeError: " " }));
      } else {
        setErrorMessage((prev) => ({ ...prev, longitudeError: "Please enter valid longitude" }));
      }
      return;
    }

    setSpeciesDetails((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const handleshowhidetype = (event) => {
    const gettype = event.target.value;
    setShowhidetype(gettype);
  };

  const handleshowhidesource = (event) => {
    const getsource = event.target.value;
    setShowhidesource(getsource);
  };

  const onAggregationLocationPoint = (position) => {
    if (isPlantationManagerReadOnly) return;

    setSpeciesDetails((prev) => ({
      ...prev,
      latitude: position?.coords?.latitude ? position?.coords?.latitude : position.Latitude,
      longitude: position?.coords?.longitude ? position?.coords?.longitude : position.Longitude
    }));
    setErrorMessage((prev) => ({ ...prev, latitudeError: " ", longitudeError: " " }));
  };

  useEffect(() => {
    if (addPlantationBatchResponse) {
      if (addPlantationBatchResponse.status === "SUCCESS") {
        toast.success(addPlantationBatchResponse?.description);
        if (urn) {
          navigate("/dashboardHome/dashboardStakeHolder");
        } else navigate("../home");
      } else {
        toast.error(
          addPlantationBatchResponse?.description ? addPlantationBatchResponse?.description : "Error"
        );
      }
    }
  }, [addPlantationBatchResponse]);

  useEffect(() => {
    if (!speciesDetails?.dateOfPlantation) return;
    getMaturedDate();
  }, [speciesDetails?.dateOfPlantation]);

  const submitPlantationBatchDetails = (finalSpeciesArr = speciesDetailsArr) => {
    loaderService.showLoader();
    apiClient
      .post(
        ADD_PLANTATION_BATCH,
        {
          id: growerPlantDetails.id,
          urn: urn ? urn : state?.urn,
          landId: selectedLandAreaId ? selectedLandAreaId : state?.landId,
          latitude: null,
          longitude: null,
          photo: growerPlantDetails?.photo,
          photoGuid: growerPlantDetails?.photoGuid,
          isSponsored: growerSponsoreDetails?.sponsoredDetails?.isSponsored,
          sponsoredType: growerSponsoreDetails?.sponsoredDetails?.sponsoredType,
          sponsoredRemarks: growerSponsoreDetails?.sponsoredDetails?.sponsoredRemarks,
          sponsoredDocument: growerSponsoreDetails?.sponsoredDetails?.sponsoredDocument,
          sponsoredDocumentGuid: growerSponsoreDetails?.sponsoredDetails?.sponsoredDocumentGuid,
          dateOfPlantation: growerPlantDetails.dateOfPlantation,
          threeYrsCompleted: growerPlantDetails.threeYrsCompleted,
          isMatured: growerPlantDetails.isMatured,
          isApproved: growerPlantDetails.isApproved,
          documentContainerName: growerPlantDetails.containerName,
          name: growerPlantDetails.name,
          landName: selectedLandArea,
          stateName: growerPlantDetails?.stateName,
          districtName: growerPlantDetails?.districtName,
          growerName: growerPlantDetails?.growerName,
          growerType: growerPlantDetails?.growerType,
          roleName: localStorage.getItem("role") ? localStorage.getItem("role") : null,
          species: finalSpeciesArr
        },

        {
          headers: {
            Authorization: "Bearer " + getLocalStorageItem("id_token")
          }
        }
      )
      .then((response) => {
        setSpeciesDetailsArr(finalSpeciesArr);
        setAddPlantationBatchResponse(response.data);
        loaderService.hideLoader();
      })
      .catch(function (error) {
        setGrowerPlantDetailsError(error);
        loaderService.hideLoader();
      });
  };

  const editPlantationBatchDetails = () => {
    loaderService.showLoader();
    apiClient
      .post(
        EDIT_PLANTATION,
        {
          ...(state?.batchItem ?? {}),
          mainTableId: state?.batchItem?.id,
          roleName: localStorage.getItem("role") ? localStorage.getItem("role") : null,
          species: [
            {
              ...speciesDetails,
              mainTableId: speciesDetails.id,
              commentDate: speciesDetails?.commentDate,
              plantationDocsList: speciesDetails?.plantationDocsAppList || []
            }
          ]
        },
        {
          headers: {
            Authorization: "Bearer " + getLocalStorageItem("id_token")
          }
        }
      )
      .then((response) => {
        setAddPlantationBatchResponse(response.data);
        loaderService.hideLoader();
      })
      .catch(function (error) {
        loaderService.hideLoader();
      });
  };

  const onUpdateSpeciesDetails = (e) => {
    if (isPlantationManagerReadOnly) return;

    e.preventDefault();

    if (!speciesDetails?.isMatured) {
      setErrorMessage((prev) => ({ ...prev, isMaturedError: "Please select matured status" }));
      return;
    }
    if (!speciesDetails?.speciesComment || !speciesDetails?.speciesComment.trim()) {
      setErrorMessage((prev) => ({
        ...prev,
        commentsError: "Please enter comment"
      }));
      return;
    }

    const mappedDocs = mapDocsToPlantationDocsAppList(documentsArr);
    setSpeciesDetails((prev) => ({
      ...prev,
      photoName: photoUploadDetails ? photoUploadDetails?.blobResponse?.fileName : prev?.photoName,
      photoGuid: photoUploadDetails ? photoUploadDetails.blobResponse.blobFileName : prev?.photoGuid,
      plantationDocsAppList: mappedDocs
    }));
    handleConfirmLogModalOpenUpdate();
  };

  function onConfirmCallBackUpdate() {
    handleConfirmLogModalCloseUpdate();
    editPlantationBatchDetails();
  }

  function onCancelBackUpdate() {
    handleConfirmLogModalCloseUpdate();
  }

  const onAddSpeciesDetails = (e) => {
    if (isPlantationManagerReadOnly) return;

    e.preventDefault();
    const currentSpeciesLandArea = AREA_REQUIRED_FOR_ONE_CLUMP * speciesDetails.noOfClumps;
    const landAreaOccupiedByAddedSpecies = Number(
      speciesDetailsArr.reduce((acc, obj) => acc + AREA_REQUIRED_FOR_ONE_CLUMP * obj.noOfClumps, 0)
    );
    const remainingLandArea = state.availableLandArea - landAreaOccupiedByAddedSpecies;
    if (!speciesDetails?.species) {
      setErrorMessage((prev) => ({ ...prev, speciesError: "Please select a species" }));
    } else if (!speciesDetails?.saplingQuantity) {
      setErrorMessage((prev) => ({ ...prev, saplingQuantityError: "Please enter sapling quantity" }));
    } else if (!speciesDetails?.dateOfPlantation) {
      setErrorMessage((prev) => ({ ...prev, dateOfPlantationError: "Please enter date" }));
    } else if (!speciesDetails?.noOfClumps) {
      setErrorMessage((prev) => ({ ...prev, noOfClumpsError: "Please enter number of clumps" }));
    } else if (!speciesDetails?.saplingType) {
      setErrorMessage((prev) => ({ ...prev, saplingTypeError: "Please select a sapling type" }));
    } else if (!speciesDetails?.saplingSource) {
      setErrorMessage((prev) => ({ ...prev, saplingSourceError: "Please select a sapling type" }));
    } else if (!speciesDetails?.latitude || !speciesDetails?.longitude) {
      setErrorMessage((prev) => ({ ...prev, latitudeError: "Please add location" }));
    } else if (!speciesDetails?.isMatured) {
      setErrorMessage((prev) => ({ ...prev, isMaturedError: "Please select matured status" }));
    } else if (!speciesDetails?.speciesComment || !speciesDetails?.speciesComment.trim()) {
      setErrorMessage((prev) => ({ ...prev, commentsError: "Please enter comment" }));
    } else if (documentsArr.length === 0) {
      setFileuploadError("Please upload at least one document/photo");
      return;
    } else if (speciesDetailsArr.find((item) => item.species === speciesDetails.species)) {
      setErrorMessage((prev) => ({ ...prev, sameSpeciesError: "Please add different species" }));
    } else if (speciesDetailsArr.find((item) => item.dateOfPlantation !== speciesDetails.dateOfPlantation)) {
      toast.error("The plantation date must be uniform for all species within a batch!");
      return;
    } else if (Number(speciesDetails?.noOfClumps) > Number(speciesDetails?.saplingQuantity)) {
      toast.error("No of clumps should be less than or equal to sapling quantity");
    } else if (remainingLandArea < currentSpeciesLandArea) {
      const possibleClumps = remainingLandArea / AREA_REQUIRED_FOR_ONE_CLUMP;
      toast.error(
        `The remaining land area i.e(${remainingLandArea} Bigha) can accommodate only ${possibleClumps} clumps.`
      );
    } else {
      setFileuploadError("");
      setShowGrid(true);
      setShowSubmitbtn(true);
      setShowAddbtn(false);
      const tempArr = [...speciesDetailsArr];
      tempArr.push({
        ...speciesDetails,
        photoName: photoUploadDetails?.blobResponse?.fileName,
        photoGuid: photoUploadDetails?.blobResponse?.blobFileName,
        landArea: state.landArea,
        usedLandForPlantation: AREA_REQUIRED_FOR_ONE_CLUMP * speciesDetails?.noOfClumps,
        plantationDocsAppList: mapDocsToPlantationDocsAppList(documentsArr)
      });
      setSpeciesDetailsArr(tempArr);
    }
  };

  const onDeleteSpeciesDetails = (e, species) => {
    if (isPlantationManagerReadOnly) return;

    e.preventDefault();
    setDeleteIndex(species);
    handleConfirmLogModalOpenDelete();
  };

  function onConfirmCallBackDelete() {
    handleConfirmLogModalCloseDelete();
    const rows = speciesDetailsArr.filter((item) => item.species !== deleteIndex);
    setSpeciesDetailsArr(rows);
    if (speciesDetailsArr.length < 2) {
      setShowGrid(false);
    }
  }

  function onCancelBackDelete() {
    handleConfirmLogModalCloseDelete();
  }

  const onSubmit = (e) => {
    if (isPlantationManagerReadOnly) return;

    e.preventDefault();

    if (!speciesDetails?.isMatured) {
      setErrorMessage((prev) => ({
        ...prev,
        isMaturedError: "Please select matured status"
      }));
      return;
    }

    if (!speciesDetails?.speciesComment || !speciesDetails?.speciesComment.trim()) {
      setErrorMessage((prev) => ({
        ...prev,
        commentsError: "Please enter comment"
      }));
      return;
    }

    const finalSpeciesArr = speciesDetailsArr.map((item, index) => {
      if (index === speciesDetailsArr.length - 1) {
        return {
          ...item,
          ...speciesDetails,
          plantationDocsAppList: mapDocsToPlantationDocsAppList(documentsArr),
          photoName:
            photoUploadDetails?.blobResponse?.fileName || item?.photoName || speciesDetails?.photoName,
          photoGuid:
            photoUploadDetails?.blobResponse?.blobFileName || item?.photoGuid || speciesDetails?.photoGuid
        };
      }
      return item;
    });

    setSpeciesDetailsArr(finalSpeciesArr);
    handleConfirmLogModalOpen();
  };

  function onConfirmCallBack() {
    handleConfirmLogModalClose();

    const finalSpeciesArr = speciesDetailsArr.map((item, index) => {
      if (index === speciesDetailsArr.length - 1) {
        return {
          ...item,
          ...speciesDetails,
          plantationDocsAppList: mapDocsToPlantationDocsAppList(documentsArr),
          photoName:
            photoUploadDetails?.blobResponse?.fileName || item?.photoName || speciesDetails?.photoName,
          photoGuid:
            photoUploadDetails?.blobResponse?.blobFileName || item?.photoGuid || speciesDetails?.photoGuid
        };
      }
      return item;
    });

    submitPlantationBatchDetails(finalSpeciesArr);
  }

  function onCancelBack() {
    handleConfirmLogModalClose();
  }

  const columns = [
    { field: "species", headerName: t("resource.species"), width: 180 },
    { field: "saplingQuantity", headerName: t("resource.saplingQuantity"), width: 180 },
    { field: "noOfClumps", headerName: t("reg.noOfClumps"), width: 180 },
    { field: "usedLandForPlantation", headerName: "Used Land Area(in Bigha)", width: 180 },
    ...(!isPlantationManagerReadOnly
      ? [
          {
            field: "actions",
            headerName: t("reg.actions"),
            width: 120,
            sortable: false,
            renderCell: (params) => (
              <Box sx={{ display: "flex", alignItems: "center", height: "100%" }}>
                <img
                  src={TrashIcon}
                  alt="delete"
                  style={{ cursor: "pointer", width: 18, height: 18 }}
                  onClick={(e) => onDeleteSpeciesDetails(e, params.row.species)}
                />
              </Box>
            )
          }
        ]
      : [])
  ];

  const commentHistoryColumns = [
    {
      field: "comment",
      headerName: "Comment",
      flex: 1.5,
      minWidth: 260,
      renderCell: (params) => (
        <Box
          sx={{
            whiteSpace: "normal",
            wordBreak: "break-word",
            lineHeight: 1.4,
            py: 1
          }}
        >
          {params.value || "-"}
        </Box>
      )
    },
    {
      field: "commentedDate",
      headerName: "Commented Date",
      flex: 1,
      minWidth: 180,
      valueGetter: (params) => {
        const rawDate =
          params?.row?.commentedDate ||
          params?.row?.commentDate ||
          params?.row?.createdOn ||
          "";
        return rawDate ? moment(rawDate).format("DD/MM/YYYY") : "-";
      }
    },
    {
      field: "commentedBy",
      headerName: "Commented By",
      flex: 1,
      minWidth: 180,
      valueGetter: (params) =>
        params?.row?.commentedBy ||
        params?.row?.commentedByName ||
        params?.row?.createdBy ||
        params?.row?.createdByName ||
        "-"
    }
  ];

  const commentHistoryRows = (commentHistoryList || []).map((item, index) => ({
    id: item?.id || index + 1,
    comment: item?.comment || "",
    commentedDate: item?.commentedDate || item?.commentDate || item?.createdOn || "",
    commentedBy:
      item?.commentedBy || item?.commentedByName || item?.createdBy || item?.createdByName || ""
  }));

  const onDeleteFile = (e, item) => {
    if (isPlantationManagerReadOnly) return;

    e.preventDefault();
    const rows = [...documentsArr];
    const index = rows.findIndex((doc) => doc === item);
    if (index !== -1) {
      rows.splice(index, 1);
      setDocumentsArr(rows);
    }
  };

  useEffect(() => {
    if (photoUploadDetails?.blobResponse) {
      setDocumentsArr((prev = []) => {
        const alreadyExists = prev.some(
          (item) => item?.blobFileName === photoUploadDetails?.blobResponse?.blobFileName
        );

        if (alreadyExists) return prev;
        return [...prev, photoUploadDetails.blobResponse];
      });
    }
  }, [photoUploadDetails]);

  useEffect(() => {
    if (state?.batchItem && state?.speciesItem) {
      const selectedSpecies =
        state?.batchItem?.species?.find((item) => item.id === state?.speciesItem?.id) ||
        state?.speciesItem;

      const mappedDocs = (
        selectedSpecies?.plantationDocsList ||
        selectedSpecies?.plantationDocsAppList ||
        []
      ).map((doc) => ({
        id: doc?.id || null,
        containerName: doc?.containerName || "resourcefiles",
        fileName: doc?.documentName || "",
        blobFileName: doc?.documentGuid || "",
        landName: doc?.landName || "",
        landId: doc?.landId || null,
        plantBatchNo: doc?.plantBatchNo || "",
        speciesDocId: doc?.speciesDocId || "",
        isActive: doc?.isActive ?? "Y",
        createdBy: doc?.createdBy,
        createdOn: doc?.createdOn,
        updatedBy: doc?.updatedBy,
        updatedOn: doc?.updatedOn
      }));

      setDocumentsArr(mappedDocs);
    }
  }, [state?.batchItem, state?.speciesItem]);

  useEffect(() => {
    if (documentsArr?.length > 0 && fileuploadError) {
      setFileuploadError("");
    }
  }, [documentsArr]);

  function mapDocsToPlantationDocsAppList(docs = []) {
    return (docs || []).map((d) => ({
      id: d?.id || null,
      containerName: d?.containerName || "resourcefiles",
      documentName: d?.fileName || d?.documentName || "",
      documentGuid: d?.blobFileName || d?.documentGuid || "",
      landName: selectedLandArea || state?.landName || "",
      landId: selectedLandAreaId || state?.landId || null,
      plantBatchNo: state?.batchItem?.plantationBatchNo || "",
      isActive: d?.isActive ?? "Y"
    }));
  }

  const pageSx = {
    px: { xs: 1, sm: 2, md: 3 },
    py: 2,
    minHeight: "100vh"
  };

  const cardSx = {
    backgroundColor: "#fff",
    borderRadius: 2,
    boxShadow: "0 1px 6px rgba(0,0,0,0.08)",
    border: "1px solid #e5e7eb",
    p: { xs: 2, sm: 2.5, md: 3 },
    mb: 2
  };

  const sectionTitleSx = {
    fontSize: "1rem",
    fontWeight: 600,
    color: "#1f2937",
    mb: 2
  };

  const formControlSx = {
    width: "100%"
  };

  const helperTextSx = {
    color: "red",
    ml: 0,
    mt: 0.5
  };

  const uploadChipSx = {
    display: "inline-flex",
    alignItems: "center",
    gap: 1,
    px: 1.5,
    py: 1,
    border: "1px solid #d1d5db",
    borderRadius: "8px",
    backgroundColor: "#f9fafb",
    fontSize: "0.875rem",
    mr: 1,
    mb: 1
  };

  const actionBtnSx = {
    minWidth: 120,
    height: 40,
    borderRadius: "8px",
    textTransform: "none",
    fontWeight: 600
  };
const handleBackButton = () => {
  if(state?.screen === "allPlantation") {
    navigate('/resourcedashboard/plantationHome/allPlantBatch', {
      state: { activeTab: state?.activeTab }
    });
  }
  else {
    navigate(-1);
  }
}
  return (
    <>
      <Container maxWidth="xl" sx={pageSx}>
        {!PROD && <p className="pageNumberingResc">RES23</p>}

        <Box sx={cardSx}>
          <Stack
            direction={{ xs: "column", sm: "row" }}
            alignItems={{ xs: "flex-start", sm: "center" }}
            justifyContent="space-between"
            spacing={2}
          >
            <Stack direction="row" alignItems="center" spacing={1}>
              {/* <BackButton navigate={navigate} /> */}
              <Fab onClick={handleBackButton} size="small" aria-label="back" title='Back'>
                          <KeyboardArrowLeftRounded />
                        </Fab>
              <Typography variant="h5" sx={{ fontWeight: 700 }}>
                {state?.batchItem ? t("resource.edit") : t("resource.add")} Plantation
              </Typography>
            </Stack>
          </Stack>

          <Box
            sx={{
              mt: 2,
              p: 2,
              borderRadius: 2,
              backgroundColor: "#f9fafb",
              border: "1px solid #e5e7eb"
            }}
          >
            <Typography variant="body2" sx={{ color: "#374151", lineHeight: 1.8 }}>
              <strong>{t("resource.growerURN")}:</strong>{" "}
              {state?.batchItem ? state?.batchItem?.urn : state?.urn}
              {"  |  "}
              <strong>{t("resource.growerName")}:</strong>{" "}
              {state?.batchItem ? state?.batchItem?.growerName : state?.growerName}
              {"  |  "}
              <strong>{t("reg.landName")}:</strong>{" "}
              {state?.batchItem
                ? state?.batchItem?.landName || state?.batchItem?.growerLandName
                : state?.landName
                ? state?.landName
                : selectedLandArea}
            </Typography>
          </Box>
        </Box>

        <Box sx={cardSx}>
          <Typography sx={sectionTitleSx}>Plantation Details</Typography>

          <Grid container spacing={2}>
            <Grid item xs={12} md={6} lg={3}>
              <FormControl sx={formControlSx}>
                <InputLabel>{t("reg.bambooSpecies")}</InputLabel>
                <Select
                  label={t("reg.bambooSpecies")}
                  name="species"
                  onChange={(e) => handleChange(e)}
                  value={speciesDetails?.species || ""}
                  disabled={isPlantationManagerReadOnly || state?.speciesItem ? true : false}
                >
                  <MenuItem>
                    <em>{t("reg.bambooSpecies")}</em>
                  </MenuItem>
                  {bambooSpecies &&
                    bambooSpecies.map((item) => (
                      <MenuItem key={item.value} value={item.value}>
                        {item.value}
                      </MenuItem>
                    ))}
                </Select>
                <FormHelperText sx={helperTextSx}>{errorMessage.speciesError}</FormHelperText>
              </FormControl>
            </Grid>

            <Grid item xs={12} md={6} lg={3}>
              <FormControl sx={formControlSx}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DesktopDatePicker
                    label={t("resource.dateOfNewPlantation")}
                    inputFormat="DD/MM/YYYY"
                    name="dateOfPlantation"
                    disabled={isPlantationManagerReadOnly || state?.speciesItem ? true : false}
                    value={speciesDetails?.dateOfPlantation}
                    onChange={(value) => handleDateChange(value)}
                    renderInput={(params) => <TextField fullWidth {...params} />}
                  />
                </LocalizationProvider>
                <FormHelperText sx={helperTextSx}>{errorMessage.dateOfPlantationError}</FormHelperText>
              </FormControl>
            </Grid>

            <Grid item xs={12} md={6} lg={3}>
              <TextField
                fullWidth
                label={t("resource.plantationMaturedDate")}
                disabled
                value={
                  speciesDetails?.maturedDate
                    ? moment(speciesDetails?.maturedDate).format("DD/MM/YYYY")
                    : ""
                }
              />
            </Grid>

            <Grid item xs={12} md={6} lg={3}>
              <FormControl sx={formControlSx}>
                <TextField
                  fullWidth
                  type="number"
                  onFocus={handleNumberFieldFocus}
                  label={t("resource.saplingQuantity")}
                  name="saplingQuantity"
                  disabled={isPlantationManagerReadOnly || state?.speciesItem ? true : false}
                  onKeyDown={(evt) =>
                    (evt.key === "e" || evt.key === "E" || evt.key === "-" || evt.key === "+") &&
                    evt.preventDefault()
                  }
                  value={speciesDetails?.saplingQuantity || ""}
                  onChange={(e) => handleChange(e)}
                />
                <FormHelperText sx={helperTextSx}>{errorMessage.saplingQuantityError}</FormHelperText>
              </FormControl>
            </Grid>

            <Grid item xs={12} md={6} lg={3}>
              <FormControl sx={formControlSx}>
                <InputLabel>{t("resource.saplingType")}</InputLabel>
                <Select
                  label={t("resource.saplingType")}
                  name="saplingType"
                  disabled={isPlantationManagerReadOnly || state?.speciesItem ? true : false}
                  value={
                    (saplingType &&
                      saplingType.find((item) => item.value === speciesDetails.saplingType)) ||
                    !speciesDetails?.saplingType
                      ? speciesDetails?.saplingType || ""
                      : "Others" || ""
                  }
                  onChange={(e) => handleChange(e)}
                >
                  <MenuItem>
                    <em>{t("resource.saplingType")}</em>
                  </MenuItem>
                  {saplingType &&
                    saplingType.map((item) => (
                      <MenuItem key={item.value} value={item.value}>
                        {item.value}
                      </MenuItem>
                    ))}
                </Select>
                <FormHelperText sx={helperTextSx}>{errorMessage.saplingTypeError}</FormHelperText>
              </FormControl>
            </Grid>

            {(state?.speciesItem
              ? !(saplingType && saplingType.find((item) => item === speciesDetails.saplingType)) ||
                speciesDetails?.saplingType === "Others"
              : showhidetype === "Others") && (
              <Grid item xs={12} md={6} lg={3}>
                <FormControl sx={formControlSx}>
                  <TextField
                    fullWidth
                    label={t("resource.otherSaplingType")}
                    name="saplingType"
                    inputProps={{ maxLength: resourceMaxLength }}
                    disabled={isPlantationManagerReadOnly || state?.speciesItem ? true : false}
                    value={speciesDetails?.saplingType || ""}
                    onChange={(e) => handleChange(e)}
                  />
                </FormControl>
              </Grid>
            )}

            <Grid item xs={12} md={6} lg={3}>
              <FormControl sx={formControlSx}>
                <InputLabel>{t("resource.saplingSource")}</InputLabel>
                <Select
                  label={t("resource.saplingSource")}
                  name="saplingSource"
                  disabled={isPlantationManagerReadOnly || state?.speciesItem ? true : false}
                  value={
                    (saplingSource &&
                      saplingSource.find((item) => item.value === speciesDetails.saplingSource)) ||
                    !speciesDetails?.saplingSource
                      ? speciesDetails?.saplingSource || ""
                      : "Others" || ""
                  }
                  onChange={(e) => handleChange(e)}
                >
                  <MenuItem>
                    <em>{t("resource.saplingSource")}</em>
                  </MenuItem>
                  {saplingSource &&
                    saplingSource.map((item) => (
                      <MenuItem key={item.value} value={item.value}>
                        {item.value}
                      </MenuItem>
                    ))}
                </Select>
                <FormHelperText sx={helperTextSx}>{errorMessage.saplingSourceError}</FormHelperText>
              </FormControl>
            </Grid>

            <Grid item xs={12} md={6} lg={3}>
              <FormControl sx={formControlSx}>
                <TextField
                  fullWidth
                  label={t("reg.noOfClumps")}
                  onKeyDown={(evt) =>
                    (evt.key === "e" || evt.key === "E" || evt.key === "-" || evt.key === "+") &&
                    evt.preventDefault()
                  }
                  type="number"
                  onFocus={handleNumberFieldFocus}
                  name="noOfClumps"
                  value={speciesDetails?.noOfClumps || ""}
                  onChange={(e) => handleChange(e)}
                  disabled={isPlantationManagerReadOnly}
                />
                <FormHelperText sx={helperTextSx}>{errorMessage.noOfClumpsError}</FormHelperText>
              </FormControl>
            </Grid>

            {(state?.speciesItem
              ? !(saplingSource && saplingSource.find((item) => item === speciesDetails.saplingSource)) ||
                speciesDetails?.saplingSource === "Others"
              : showhidesource === "Others") && (
              <Grid item xs={12} md={6} lg={3}>
                <FormControl sx={formControlSx}>
                  <TextField
                    fullWidth
                    label={t("resource.otherSaplingSource")}
                    name="saplingSource"
                    inputProps={{ maxLength: resourceMaxLength }}
                    disabled={isPlantationManagerReadOnly || state?.speciesItem ? true : false}
                    value={speciesDetails?.saplingSource || ""}
                    onChange={(e) => handleChange(e)}
                  />
                </FormControl>
              </Grid>
            )}

            <Grid item xs={12} md={6} lg={3}>
              <FormControl sx={formControlSx}>
                <TextField
                  fullWidth
                  label={t("reg.avgClumpSize")}
                  type="number"
                  onFocus={handleNumberFieldFocus}
                  name="averageClumpSize"
                  onKeyDown={(evt) =>
                    (evt.key === "e" || evt.key === "E" || evt.key === "-" || evt.key === "+") &&
                    evt.preventDefault()
                  }
                  value={speciesDetails?.averageClumpSize || ""}
                  onChange={(e) => handleChange(e)}
                  disabled={isPlantationManagerReadOnly || !state?.speciesItem}
                />
              </FormControl>
            </Grid>

            <Grid item xs={12} md={6} lg={3}>
              <FormControl sx={formControlSx}>
                <TextField
                  fullWidth
                  label={t("resource.averageBambooPoleWeightinKg")}
                  type="number"
                  onFocus={handleNumberFieldFocus}
                  inputProps={{ maxLength: resourceMaxLength }}
                  onKeyDown={(evt) =>
                    (evt.key === "e" || evt.key === "E" || evt.key === "-" || evt.key === "+") &&
                    evt.preventDefault()
                  }
                  name="avgBambooPolWgt"
                  value={speciesDetails.avgBambooPolWgt || ""}
                  onChange={(e) => handleChange(e)}
                  disabled={isPlantationManagerReadOnly}
                />
                <FormHelperText sx={helperTextSx}>{errorMessage.avgBambooPolWgtError}</FormHelperText>
              </FormControl>
            </Grid>
          </Grid>
        </Box>

        <Box sx={cardSx}>
          <Typography sx={sectionTitleSx}>Location</Typography>

          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Box
                sx={{
                  mt: 1,
                  p: 2,
                  borderRadius: 2,
                  border: "1px solid #e5e7eb",
                  backgroundColor: "#f9fafb"
                }}
              >
                <LocationPointMUI
                  latitudeName={t("preReg.latitude")}
                  longitudeName={t("preReg.longitude")}
                  latitude={speciesDetails.latitude}
                  longitude={speciesDetails.longitude}
                  callBackLocation={onAggregationLocationPoint}
                  isDisabled={isPlantationManagerReadOnly || state?.speciesItem ? true : false}
                  isResource={true}
                />
                <div className="resource-common-error-message">
                  {errorMessage.latitudeError || errorMessage.longitudeError}
                </div>
              </Box>
            </Grid>
          </Grid>
        </Box>

        <Box sx={cardSx}>
          <Typography sx={sectionTitleSx}>Plantation Status</Typography>

          <Grid container spacing={2}>
            <Grid item xs={12} md={6} lg={3}>
              <FormControl sx={formControlSx}>
                <Typography sx={{ fontSize: "0.875rem", mb: 1 }}>
                  Is Matured <span style={{ color: "red" }}>*</span>
                </Typography>
                <RadioGroup
                  row
                  name="isMatured"
                  value={speciesDetails?.isMatured || ""}
                  onChange={(e) => handleChange(e)}
                >
                  <FormControlLabel
                    value="Y"
                    control={<Radio size="small" />}
                    label="Yes"
                    disabled={isPlantationManagerReadOnly}
                  />
                  <FormControlLabel
                    value="N"
                    control={<Radio size="small" />}
                    label="No"
                    disabled={isPlantationManagerReadOnly}
                  />
                </RadioGroup>
                <FormHelperText sx={helperTextSx}>{errorMessage.isMaturedError}</FormHelperText>
              </FormControl>
            </Grid>

            {state?.speciesItem && (
              <Grid item xs={12} md={6} lg={3}>
                <FormControl sx={formControlSx}>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DesktopDatePicker
                      label="Updated Date"
                      inputFormat="DD/MM/YYYY"
                      value={speciesDetails?.commentDate}
                      onChange={(value) => handleUpdateChange(value)}
                      renderInput={(params) => <TextField fullWidth {...params} />}
                      disabled={isPlantationManagerReadOnly}
                    />
                  </LocalizationProvider>
                </FormControl>
              </Grid>
            )}

            {commentHistoryRows.length > 0 && (
              <Grid item xs={12} lg={12}>
                <Typography sx={{ fontSize: "0.95rem", fontWeight: 600, mb: 1 }}>
                  Comment History
                </Typography>
                <Box sx={{ width: "100%" }}>
                  <DataGrid
                    autoHeight
                    rows={commentHistoryRows}
                    columns={commentHistoryColumns}
                    pageSize={5}
                    rowsPerPageOptions={[5, 10]}
                    disableSelectionOnClick
                    getRowHeight={() => "auto"}
                    sx={{
                      borderRadius: 2,
                      "& .MuiDataGrid-columnHeaders": {
                        backgroundColor: "#f3f4f6",
                        fontWeight: 600
                      },
                      "& .MuiDataGrid-cell": {
                        alignItems: "center"
                      }
                    }}
                  />
                </Box>
              </Grid>
            )}

            <Grid item xs={12} md={6} lg={9}>
              <FormControl sx={formControlSx}>
                <TextField
                  fullWidth
                  multiline
                  minRows={4}
                  label="Add Comment *"
                  name="speciesComment"
                  value={speciesDetails?.speciesComment || ""}
                  onChange={(e) => handleChange(e)}
                  disabled={isPlantationManagerReadOnly}
                  inputProps={{ maxLength: COMMENT_MAX_LENGTH }}
                  error={!!errorMessage.commentsError}
                />
                <Stack direction="row" justifyContent="space-between" alignItems="center">
                  <FormHelperText sx={helperTextSx}>{errorMessage.commentsError}</FormHelperText>
                  <Typography variant="caption" sx={{ color: "#6b7280", mt: 0.5 }}>
                    {(speciesDetails?.speciesComment || "").length}/{COMMENT_MAX_LENGTH}
                  </Typography>
                </Stack>
              </FormControl>
            </Grid>
          </Grid>
        </Box>

        <Box sx={cardSx}>
          <Typography sx={sectionTitleSx}>Upload Documents / Photos</Typography>

          <Stack spacing={2}>
            {!isPlantationManagerReadOnly && (
              <Box>
                <label
                  className="view-file-link-common"
                  style={{
                    display: "inline-block",
                    padding: "10px 16px",
                    borderRadius: "8px",
                    background: "#1976d2",
                    color: "#fff",
                    cursor: "pointer",
                    fontWeight: 500
                  }}
                >
                  <input
                    style={{ display: "none" }}
                    type="file"
                    accept="image/jpeg, image/jpg, image/png, .pdf"
                    name="photo"
                    onChange={(e) => uploadPhoto(e)}
                    disabled={isPlantationManagerReadOnly}
                  />
                  Upload File
                </label>
              </Box>
            )}

            <Box sx={{ display: "flex", flexWrap: "wrap" }}>
              {documentsArr?.map((item, index) => (
                <Box key={`${item?.blobFileName || item?.fileName}-${index}`} sx={uploadChipSx}>
                  <Link
                    component="button"
                    type="button"
                    underline="hover"
                    onClick={() =>
                      viewdownloadDocument(
                        item?.blobFileName || item?.documentGuid,
                        item?.fileName || item?.documentName,
                        "View"
                      )
                    }
                    sx={{
                      maxWidth: 220,
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                      display: "inline-block",
                      textAlign: "left"
                    }}
                    title={item?.fileName || item?.documentName}
                  >
                    {item?.fileName || item?.documentName}
                  </Link>

                  {!isPlantationManagerReadOnly && (
                    <img
                      src={TrashIcon}
                      style={{ cursor: "pointer", height: "18px", width: "18px" }}
                      alt="TrashIcon"
                      onClick={(e) => onDeleteFile(e, item)}
                    />
                  )}
                </Box>
              ))}
            </Box>

            <Typography variant="body2" sx={{ color: "#15803d" }}>
              {t("preReg.uploadFileTypeNote")}
            </Typography>

            <div className="resource-knowledge-error-message">{fileuploadError}</div>
          </Stack>
        </Box>

        {showGrid && (
          <Box sx={cardSx}>
            <Typography sx={sectionTitleSx}>Added Species</Typography>
            <Box sx={{ width: "100%" }}>
              <DataGrid
                autoHeight
                rows={speciesDetailsArr}
                columns={columns}
                pageSize={10}
                getRowId={(row) => row?.species}
                hideFooterPagination
                sx={{
                  borderRadius: 2,
                  "& .MuiDataGrid-columnHeaders": {
                    backgroundColor: "#f3f4f6",
                    fontWeight: 600
                  }
                }}
              />
            </Box>
            <div style={{ marginTop: "8px" }} className="resource-common-error-message">
              {errorMessage.sameSpeciesError}
            </div>
          </Box>
        )}

        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            gap: 1.5,
            flexWrap: "wrap",
            pb: 2
          }}
        >
          {!isPlantationManagerReadOnly && showAddbtn && !state?.speciesItem && (
            <Button sx={actionBtnSx} variant="contained" onClick={(e) => onAddSpeciesDetails(e)}>
              {t("reg.add")}
            </Button>
          )}

          {!isPlantationManagerReadOnly && state?.speciesItem && (
            <Button sx={actionBtnSx} variant="contained" onClick={(e) => onUpdateSpeciesDetails(e)}>
              {t("reg.update")}
            </Button>
          )}

          {!isPlantationManagerReadOnly && showSubmitbtn && (
            <>
              <Button sx={actionBtnSx} variant="outlined" onClick={(e) => onAddSpeciesDetails(e)}>
                {t("reg.add")}
              </Button>

              <Button sx={actionBtnSx} variant="contained" onClick={(e) => onSubmit(e)}>
                {t("preReg.submit")}
              </Button>
            </>
          )}
        </Box>
      </Container>

      <ConfirmationPopover
        onOpen={logConfirmModalOpen}
        onConfirm={onConfirmCallBack}
        onClose={onCancelBack}
        action="Submit"
      />
      <ConfirmationPopover
        onOpen={logConfirmModalOpenUpdate}
        onConfirm={onConfirmCallBackUpdate}
        onClose={onCancelBackUpdate}
        action="Update"
      />
      <ConfirmationPopover
        onOpen={logConfirmModalOpenDelete}
        onConfirm={onConfirmCallBackDelete}
        onClose={onCancelBackDelete}
        action="Delete"
      />
    </>
  );
}

export default AddPlantation;